<template>
	<v-container fluid>
		<div v-if="!loading">
			<div id="print-habits-pdf">
				<!--table -->
				<v-row class="total secondary--text mb-4">Products</v-row>
				<!--table head-->
				<v-row class="total mt-4" no-gutters>
					<v-col class="tabCell text-left">Brand & model</v-col>
					<v-col class="tabCell" v-for="item in headers"
						:key="item">
						{{item}}
					</v-col>
				</v-row>
				<!--table content-->
				<div v-if="allProducts.length">
					<v-expansion-panels multiple v-model="panel">
						<v-expansion-panel
							v-for="brand in allProducts"
							:key="brand.id"
						>
							<v-expansion-panel-header class="subtitle-2 secondary--text" expand-icon="mdi-menu-down">
								{{ brand.trademark }}
							</v-expansion-panel-header>
							<v-expansion-panel-content>
								<v-row v-for="model in brand.models" :key="model.id" no-gutters>
									<v-col class="tabCell text-left">{{ name(model.model) }}</v-col>
									<v-col class="tabCell">{{ model.retailPrice}}</v-col>
									<v-col class="tabCell">{{ model.designType}}</v-col>
									<v-col class="tabCell">{{ model.designLevel}}</v-col>
									<v-col class="tabCell">{{ model.material}}</v-col>
									<v-col class="tabCell">{{ model.manufacturing}}</v-col>
									<v-col class="tabCell">{{ model.variations}}</v-col>
									<v-col class="tabCell">{{ model.advancedFeature}}</v-col>
									<v-col class="tabCell">{{ format(lastSales(model))}}</v-col>
								</v-row>
							</v-expansion-panel-content>
						</v-expansion-panel>
					</v-expansion-panels>
				</div>
				<div v-else>
					<v-row justify="center" class="body-2 mt-8">
						<strong>There are no products yet</strong>
					</v-row>
				</div>
			</div>
			<v-row class="ma-4" justify="end">
				<v-btn
					color="#1A237E" small dark
					class="text-lowercase"
					@click="generateReport"
					>save in PDF
				</v-btn>
			</v-row>	
		</div>
		<div v-else class="text-center">
			<loader></loader>
		</div> 
	</v-container>
</template>
<script>
	import numeral from 'numeral'
	import html2pdf from 'html2pdf.js'
	import Loader from '../../../layouts/Loader.vue'

	export default {
		props: ['company', 'gameId', 'round'],
		data (){
			return {
				headers: ['Retail price', 'Design type', 'Design level', 'Material level', 'Manufacturing level', 'Variations', 'Advanced feature', 'Sales last year'],
				panel: [0,1]
				
			}
		},		
		computed: {
			loading () {
				return this.$store.getters.loading
			},
			allProducts() {
				return this.$store.getters.allProducts
			},
			adjustedSales () {
				return this.$store.getters.adjustedSales
			}
		},
		async mounted() {			
			const obj = {
				gameId: this.$route.query.game,
				round: this.$route.query.round
			}
			//console.log(obj)
			try {
				//get allProducts
				await this.$store.dispatch('fetchAllProducts', obj)	
			}
			catch (error) { throw error }
		},
		methods: {
			//format in numeral
			format (param) {
				return numeral(param).format('0,0[.]0')//
			},
			name (model) {
				return model.split(' - ')[1] //trademark cutted name
			},
			lastSales (model) {
				let sales = 0
				this.adjustedSales.forEach(month => {
					month.forEach(segment => {
						const matchModel = segment.models.find(mod => mod.modelId === model.modelId)
						if (matchModel) {
							sales+= matchModel.adjustedSales
						}
					})
				})
				return sales
			},
			generateReport () {
				let element = document.getElementById('print-habits-pdf');
				var opt = {
					margin: 1,
					filename: 'products.pdf',
					image: { type: 'jpeg', quality: 0.98 },
					html2canvas:  { scale: 2 },
					jsPDF: { unit: 'in', format: 'letter', orientation: 'landscape' }
				};
				// New Promise-based usage:
				html2pdf().set(opt).from(element).save();
			}
		},
		components: {Loader}
	}
</script>